import React from 'react';
import Icon from 'components/AppIcon';
import Input from 'components/ui/Input';

const INCOME_RANGES = [
  { value: 'under_30k', label: 'Under $30,000', min: 0, max: 30000, mid: 20000 },
  { value: '30k_50k', label: '$30,000 – $50,000', min: 30000, max: 50000, mid: 40000 },
  { value: '50k_75k', label: '$50,000 – $75,000', min: 50000, max: 75000, mid: 62500 },
  { value: '75k_100k', label: '$75,000 – $100,000', min: 75000, max: 100000, mid: 87500 },
  { value: '100k_150k', label: '$100,000 – $150,000', min: 100000, max: 150000, mid: 125000 },
  { value: 'over_150k', label: 'Over $150,000', min: 150000, max: 300000, mid: 200000 },
];

const EMPLOYMENT_TYPES = [
  { value: 'full_time', label: 'Full-Time Employee', icon: 'Briefcase' },
  { value: 'part_time', label: 'Part-Time Employee', icon: 'Clock' },
  { value: 'self_employed', label: 'Self-Employed', icon: 'Building2' },
  { value: 'freelance', label: 'Freelancer', icon: 'Laptop' },
  { value: 'student', label: 'Student', icon: 'GraduationCap' },
  { value: 'retired', label: 'Retired', icon: 'Sunset' },
];

export default function IncomeStep({ data, onChange }) {
  const handleRangeSelect = (range) => {
    onChange({ ...data, incomeRange: range?.value, estimatedIncome: range?.mid });
  };

  const handleEmploymentSelect = (type) => {
    onChange({ ...data, employmentType: type });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-base font-semibold text-[#F8FAFC] mb-1">Annual Income Range</h3>
        <p className="text-sm text-[#94A3B8] mb-4">Select the range that best describes your annual household income.</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {INCOME_RANGES?.map((range) => (
            <button
              key={range?.value}
              onClick={() => handleRangeSelect(range)}
              className={`p-3 rounded-lg border text-left transition-all duration-200 min-h-[44px] ${
                data?.incomeRange === range?.value
                  ? 'border-[#06B6D4] bg-[rgba(6,182,212,0.12)] text-[#06B6D4]'
                  : 'border-[rgba(6,182,212,0.15)] bg-[rgba(15,23,42,0.6)] text-[#CBD5E1] hover:border-[rgba(6,182,212,0.35)] hover:bg-[rgba(6,182,212,0.06)]'
              }`}
            >
              <span className="text-xs md:text-sm font-medium">{range?.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div>
        <h3 className="text-base font-semibold text-[#F8FAFC] mb-1">Employment Type</h3>
        <p className="text-sm text-[#94A3B8] mb-4">How would you describe your primary employment?</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {EMPLOYMENT_TYPES?.map((type) => (
            <button
              key={type?.value}
              onClick={() => handleEmploymentSelect(type?.value)}
              className={`flex items-center gap-2 p-3 rounded-lg border transition-all duration-200 min-h-[44px] ${
                data?.employmentType === type?.value
                  ? 'border-[#06B6D4] bg-[rgba(6,182,212,0.12)] text-[#06B6D4]'
                  : 'border-[rgba(6,182,212,0.15)] bg-[rgba(15,23,42,0.6)] text-[#CBD5E1] hover:border-[rgba(6,182,212,0.35)] hover:bg-[rgba(6,182,212,0.06)]'
              }`}
            >
              <Icon
                name={type?.icon}
                size={16}
                color={data?.employmentType === type?.value ? '#06B6D4' : '#94A3B8'}
              />
              <span className="text-xs md:text-sm font-medium">{type?.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div>
        <h3 className="text-base font-semibold text-[#F8FAFC] mb-1">Additional Income Sources</h3>
        <p className="text-sm text-[#94A3B8] mb-4">Any other monthly income? (optional)</p>
        <Input
          type="number"
          label="Monthly Additional Income ($)"
          placeholder="e.g. 500"
          value={data?.additionalIncome || ''}
          onChange={(e) => onChange({ ...data, additionalIncome: e?.target?.value })}
        />
      </div>
    </div>
  );
}